import { render, staticRenderFns } from "./OpenaiIcon.vue?vue&type=template&id=9f34e608&scoped=true"
import script from "./OpenaiIcon.vue?vue&type=script&lang=js"
export * from "./OpenaiIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f34e608",
  null
  
)

export default component.exports